import { OLAF } from 'HubStyleTokens/colors';
import { H3 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { CARD_BORDER_RADIUS } from 'developer-docs-shared-components/config/cssConstants';
import { COMET, ECLIPSE } from 'developer-docs-shared-components/config/cssConstants';
import LinkOverlay, { embeddedLinkStyles } from './LinkOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardHeader = styled(H3).withConfig({
  displayName: "WhatsNewCard__CardHeader",
  componentId: "sc-18h6jr-0"
})(["font-weight:500;font-size:24px;", "{padding-top:0;}"], mediaQueries.belowTablet);
const StyledUICardWrapper = styled(UICardWrapper).withConfig({
  displayName: "WhatsNewCard__StyledUICardWrapper",
  componentId: "sc-18h6jr-1"
})(["background-color:", ";color:", ";border-radius:", "px;display:flex;flex-direction:row;position:relative;transition:0.3s ease-in-out;&:hover{background:", ";}"], ({
  background
}) => background, OLAF, CARD_BORDER_RADIUS, ECLIPSE);
const ContentWrapper = styled.div.withConfig({
  displayName: "WhatsNewCard__ContentWrapper",
  componentId: "sc-18h6jr-2"
})(["display:flex;flex-direction:column;justify-content:space-between;align-items:start;width:100%;"]);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "WhatsNewCard__StyledRouterLink",
  componentId: "sc-18h6jr-3"
})(["color:", ";border-color:", ";", " &:hover{color:", ";border-color:", ";}"], OLAF, OLAF, embeddedLinkStyles, COMET, COMET);
const UICardHeaderSection = styled(UICardSection).withConfig({
  displayName: "WhatsNewCard__UICardHeaderSection",
  componentId: "sc-18h6jr-4"
})(["padding-bottom:25px;"]);
const UICardDescriptionSection = styled(UICardSection).withConfig({
  displayName: "WhatsNewCard__UICardDescriptionSection",
  componentId: "sc-18h6jr-5"
})(["padding-bottom:30px;"]);
export const WhatsNewCard = ({
  description,
  header,
  illustration,
  link,
  background
}) => {
  const {
    isMobile
  } = useViewport() || {
    isMobile: false
  };
  return /*#__PURE__*/_jsxs(StyledUICardWrapper, {
    background: background,
    children: [!isMobile && /*#__PURE__*/_jsx(UIIllustration, {
      loading: "lazy",
      className: "m-left-10",
      name: illustration,
      width: 100,
      alt: illustration
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [isMobile && /*#__PURE__*/_jsx(UICardSection, {
        children: /*#__PURE__*/_jsx(UIIllustration, {
          loading: "lazy",
          className: illustration === 'building' ? 'p-top-4' : undefined,
          width: 80,
          height: 95,
          name: illustration,
          alt: illustration
        })
      }), /*#__PURE__*/_jsx(UICardHeaderSection, {
        children: /*#__PURE__*/_jsx(CardHeader, {
          children: header
        })
      }), /*#__PURE__*/_jsx(UICardDescriptionSection, {
        children: description
      }), /*#__PURE__*/_jsx(UICardSection, {
        children: /*#__PURE__*/_jsx(StyledRouterLink, {
          to: link,
          href: link,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.mainLandingPage.whatsNew.buttonText"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(LinkOverlay, {
      to: link
    })]
  });
};